export const FILTERED_POSTS_LIMIT = 50;
export const COMMENTS_LIMIT = 50;
